"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { HostingMapSkeleton } from "@/components/domain/hosting/hosting-map-skeleton";
import { useIsClient } from "@/hooks/use-is-client";
const HostingMapClient = dynamic(() => import("@/components/domain/hosting/hosting-map-client").then(m => m.HostingMapClient), {
  ssr: false,
  loading: () => <HostingMapSkeleton />
});

/**
 * Keep the map off the server HTML and the first client paint.
 * `next/dynamic` with `ssr: false` still hydrates the real module when the
 * chunk is already available, which mismatches the server skeleton.
 */
export function HostingMap(t0) {
  const $ = _c(5);
  const {
    lat,
    lon,
    domain
  } = t0;
  const mounted = useIsClient();
  if (!mounted) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <HostingMapSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== domain || $[2] !== lat || $[3] !== lon) {
    t1 = <HostingMapClient lat={lat} lon={lon} domain={domain} />;
    $[1] = domain;
    $[2] = lat;
    $[3] = lon;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}